module.exports = __webpack_public_path__ + "images/category_lp/tablet/store_images/3_9f98de4f40a9e03f60aaf37166db8905.png";